import { Container, Sprite , Text } from "pixi.js";
import { MultiBonusCommonConfiguration, MultiBonusType, SpinAndHoldStartAction } from "../../../api";
import { CreateSpineResources, Point, Rect, Safe, Scale, TranslateScreen1To1 } from "../../../MyHelpers";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, LoadingStage } from "../../../ResourceManager/ResourceManager";
import { Settings } from "../../../Settings";
import { MultiPotName } from "../../FillingPot/FamilyMultiBonusConstructiveFeature";
import { LayoutPotElement } from "../../FillingPot/LayoutPotElement";
import { IBonusStartConfig } from "../../SlotGame";
import { ConstructReelsParams } from "../SlotBonus";
import { SpinAndHoldParams } from "../SpinAndHold/SpinAndHoldParams";
import { SpinAndHoldBonusPIXIAPP } from "../SpinAndHold/SpinAndHoldPIXIAPP";
import { service } from "../../../services";
import { SpinAndHoldState } from "../SpinAndHold/SpinAndHoldState";
import { ITimeout } from "../../../Context/Timeout";
import gsap, { TweenLite } from 'gsap';

export class MultiBonusPIXIApp extends SpinAndHoldBonusPIXIAPP {
	protected override BonusName(): string {
		return "MultiBonus";
	}
	protected layoutPotsElementsMap: Map<string, LayoutPotElement> = new Map<string, LayoutPotElement>()

	public constructor(gameName: string, params: SpinAndHoldParams, config: MultiBonusCommonConfiguration) {
		super(gameName, params, config);

		MultiPotName.forEach(name => {
			this.layoutPotsElementsMap.set(name, new LayoutPotElement(name, `${Settings.ResourcesFolder}multigame/slot/${this.gameName}/resources/`, gameName, this.systemContext , this.audio , this.resid))
		});

		this.bonusMultiplier = null;

		this.timeoutCometShowtime = this.systemContext.TimingContext().CreateTimeout("timeoutCometShowtime", 1000, () => { this.CometShowtime(this.scatterPositions[this.currentScatterCometIndex]) });
		this.timeoutSRAPlusOne = this.systemContext.TimingContext().CreateTimeout("timeoutSRAPlusOne", 500, () => {
			this.stateMachine.ChangeState(SpinAndHoldState.BigWin);			
			this.spineBonusTitle?.state?.setAnimation(0,"anim",false);
			if(this.spinsStats != null) this.spinsStats.text = this.translator.t.bonusSpinsRemainingAndTotal(this.session.RunsRemaining, this.TotaltSpins);
			if(this.spinRemainingTextPIXIAPP != null)this.spinRemainingTextPIXIAPP.text = this.session.RunsRemaining;
		});
	}

	protected override ConstructReels2(constructReelsParams: ConstructReelsParams) {
		super.ConstructReels2(constructReelsParams);
	}

	protected override CreateContainersPIXIAPPScreen1() {
		super.CreateContainersPIXIAPPScreen1();		
		this.CreateLayoutBonus();
		let indexpot = 0;
		let layoutsContainerIntroMessage: Container = new Container();
		layoutsContainerIntroMessage.name = "layoutsContainerIntroMessage";
		//layoutsContainerIntroMessage.width = this.introMessageContainerPIXIAPP.width;
		//layoutsContainerIntroMessage.width = Settings.ScreenWidth;
		
		this.introMessageContainerPIXIAPP.addChild(layoutsContainerIntroMessage);
		this.startAction.Types.forEach(potNameVarian => {
			//this.layoutPotsElementsMap.get(potNameVarian).Enable();
			let layoutSprite = Sprite.from(this.layoutPotsElementsMap.get(potNameVarian).GetScreenShotLayout());
			layoutSprite.scale.set(Scale.XY(0.5));
			//if (this.playWindow.Height >= 5) layoutSprite.scale.set(Scale.XY(0.4));
			layoutsContainerIntroMessage.addChild(layoutSprite);
			layoutSprite.position.set(indexpot * (layoutSprite.width + Scale.XY(25)), 0);
			indexpot++;
		});

		//fix pivot
		layoutsContainerIntroMessage.pivot.set(layoutsContainerIntroMessage.width / 2, layoutsContainerIntroMessage.height / 2);
		layoutsContainerIntroMessage.position.set(Scale.W(1152 / 2), Scale.H(452.5));

		this.spriteintroTextureMessageContainerApp.scale.set(Scale.XY(1));
		this.spriteintroTextureMessageContainerApp.position.set(Scale.X(576.5), Scale.Y(226.5));
		this.buttonIntroContainerApp.y = Scale.H(650);
		this.buttonIntroContainerApp.scale.set(Scale.XY(1));
		//this.buttonIntroContainerApp.x = Scale.H(1152) / 2 ;

		//----------------------------------------------------------------Final Message ------------------------------------------------------------------------------------------------------------------------------
		indexpot = 0;
		//this.finalMessageContainerPIXIAPP.addChild(layoutsContainerMessage.);
		let layoutsContainerFinalMessage: Container = new Container();
		layoutsContainerFinalMessage.name = "layoutsContainerFinalMessage";
		//layoutsContainerFinalMessage.width = this.introMessageContainerPIXIAPP.width;
		//layoutsContainerFinalMessage.width = Settings.ScreenWidth;
		this.finalMessageContainerPIXIAPP.addChild(layoutsContainerFinalMessage);
		this.startAction.Types.forEach(potNameVarian => {			
			let layoutSprite = Sprite.from(this.layoutPotsElementsMap.get(potNameVarian).GetScreenShotLayout());
			layoutSprite.scale.set(Scale.XY(0.5));
			layoutsContainerFinalMessage.addChild(layoutSprite);
			layoutSprite.position.set(indexpot * (layoutSprite.width + Scale.XY(25)), 0);
			indexpot++;
		});

		//fix pivot
		layoutsContainerFinalMessage.pivot.set(layoutsContainerFinalMessage.width / 2, layoutsContainerFinalMessage.height / 2);
		layoutsContainerFinalMessage.position.set(Scale.W(1152 / 2), Scale.H(452.5));

		this.spritefinalTextureMessageContainerApp.scale.set(Scale.XY(1));
		this.spritefinalTextureMessageContainerApp.position.set(Scale.X(576.5), Scale.Y(226.5));
		this.finalbuttonIntroContainerApp.y = Scale.H(650);
		this.finalbuttonIntroContainerApp.scale.set(Scale.XY(1));
		//this.finalbuttonIntroContainerApp.x = Scale.H(1152) / 2 ;
		indexpot = null;
		
	}

	protected override CreateTitleStckySpin() {
		if (this.playWindow.Height >= 5) return
		//create container and spine bonus title 
		let bonusTitleContainer = new Container();
		bonusTitleContainer.name = "bonusTitleContainer";
		this.bonusGameInfoStats.addChild(bonusTitleContainer);
		this.spineBonusTitle = CreateSpineResources(this.jsonBonusTitleSpine);

		bonusTitleContainer.x = Settings.ScreenWidth / 2;
		bonusTitleContainer.y = Scale.Y(144);
		bonusTitleContainer.addChild(this.spineBonusTitle);
		bonusTitleContainer.pivot.set(this.spineBonusTitle.width / 2, this.spineBonusTitle.height / 2);
		//this.spineBonusTitle = spineBonusTitle;
	}

	protected layoutsContainer : Container = null;
	protected CreateLayoutBonus(){
		console.log("MultiBonus-ReelSize : ", this.playWindow);
		this.layoutsContainer = new Container();
		this.layoutsContainer.name = "layoutsContainerStats";
		this.layoutsContainer.width = Settings.ScreenWidth;
		//this.layoutsContainer.position.set(Scale.X(66) , Scale.Y())
		this.containerBonusViewApp.addChild(this.layoutsContainer)
		let indexpot = 1;
		this.startAction.Types.forEach(potNameVarian => {
			this.layoutPotsElementsMap.get(potNameVarian).CreateElementIntoContainer(this.layoutsContainer, this.playWindow.Height >= 5 ?  Scale.XY(0.6) : Scale.XY(0.7) , indexpot , this.playWindow.Height >= 5 ? 4 : 3);
			this.layoutPotsElementsMap.get(potNameVarian).Enable();
			if(this.layoutPotsElementsMap.get(potNameVarian).potName == "Multiplier") this.layoutPotsElementsMap.get(potNameVarian).SetMultiplier(this.multiplierHit);
			indexpot++;
		});


		this.layoutsContainer.position.set(Scale.X(-114), Settings.ScreenHeight * (Settings.Screens - 1) - Scale.Y(100));
		//SetNewPosition if you win more symbols 
		if (this.playWindow.Height >= 5) this.layoutsContainer.position.set(Scale.X(-49), Scale.Y(1145.5))
			if (this.playWindow.Height >= 5 && Settings.Screens == 2) this.layoutsContainer.position.set(Scale.X(-49), Scale.Y(66.5))

		//AddScreenShot Layout to message intro and final message container 
		indexpot = null;
		
		//this.CreateInfoStats(layoutsContainer)
	}

	protected spinsStats: Text = null;
	//protected updateSpin : number = 1;
	protected CreateInfoStats(container : Container){
		// if (this.playWindow.Height < 5) return
		// //create spine frame 
		// let spineFrame = CreateSpineResources(this.jsonSpinsRemainingSpine, 0.8);
		// container.addChild(spineFrame);
		// spineFrame.name = "FrameSpinsRemaining";
		// spineFrame?.state.setAnimation(0,"anim",true);
		// spineFrame.position.set(Scale.X(1466.5), Scale.Y(-69));
		// //only use if you are win double bonus 
		// //create Win Text SRA
		// this.spinsStats = new Text(this.translator.t.bonusSpinsRemainingAndTotal(this.session.RunsRemaining,this.TotaltSpins),{
        //     fontFamily: 'NotoSansDisplay-Bold',			
		// 	fontSize: 50,			
		// 	fontWeight: 'bold',
		// 	fill: ["#F20505", "#F20505", "#F20505", "#F20505", "#F20505"], // gradient
		// 	stroke: 'white',
		// 	strokeThickness: 10,
		// 	dropShadow : true,
		// 	dropShadowColor : "#000000",
		// 	dropShadowDistance : 5,
		// 	dropShadowAngle : 0.52,	
		// 	dropShadowAlpha : 1,		
		// 	//wordWrap: true,			
		// 	lineJoin: 'round',
		// 	//textBaseline : "middle",			
        // });
		// this.spinsStats.anchor.set(0.5,0.5);	
		// this.spinsStats.scale.y = -1;
		// //this.spinsStats.position.set(Scale.X(1644), 0 );

		// //add text into spine
		// let containerchildrensSpineWinCount = spineFrame?.children as Container[];
		// containerchildrensSpineWinCount?.forEach((container) => {
		// 	if (container.name == "containerValue") {
		// 		container.addChild(this.spinsStats);
		// 		//container.addChild(winTextPIXIAPP);
		// 	}
		// });
		// //container.addChild(this.spinsStats);

		// this.translator.SetOnLanguageChangedCallback(() => {
		// 	this.spinsStats.text = this.translator.t.bonusSpinsRemainingAndTotal(this.session.RunsRemaining, this.TotaltSpins)
		// });
	}

	protected override CreateScatterWinCount() {
		if (this.playWindow.Height >= 5) return
		//create container and spine WinCount 
		let scatterWinCountContainer = new Container();		
		scatterWinCountContainer.name = "scatterWinCountContainer";
		this.bonusGameInfoStats.addChild(scatterWinCountContainer);
		this.spineWinCountContainer = CreateSpineResources(this.jsonWinCountSpine , true,0.8);
		scatterWinCountContainer.x = Scale.X(960);
		scatterWinCountContainer.y = Scale.Y(466.6);
		scatterWinCountContainer.addChild(this.spineWinCountContainer);
		scatterWinCountContainer.pivot.set(this.spineWinCountContainer.width / 2, this.spineWinCountContainer.height / 2);
		this.spineWinCountContainer?.state.setAnimation(0, "anim", true);
		//scatterWinCountContainer.scale.set(0.8);
	}
	protected spinsRemainingContainer: Container = null;	
	protected override CreateSpinsRemaining() {
		//if (this.playWindow.Height >= 5) return
		//create container and spine Spins Remaining
		this.spinsRemainingContainer = new Container();
		this.spinsRemainingContainer.x = Settings.ScreenWidth / 2;
		this.spinsRemainingContainer.name = "spinsRemainingContainer";
		
		this.spineSpinsRemaining = CreateSpineResources(this.jsonSpinsRemainingSpine);
		this.spinsRemainingContainer.addChild(this.spineSpinsRemaining);
		
		
		//this.spineSpinsRemaining.scale.set(Scale.XY(1.5));
		//this.spineSpinsRemaining.state.apply(this.spineSpinsRemaining.skeleton);
		//this.spineSpinsRemaining.state.update(0);
		
		if(this.playWindow.Height < 4 ) {
			this.bonusGameInfoStats.addChild(this.spinsRemainingContainer)
			this.spinsRemainingContainer.y = (Settings.ScreenHeight - this.spineSpinsRemaining.height / 2) - Scale.XY(200)
		}
		else {
			this.layoutsContainer.addChild(this.spinsRemainingContainer);
			this.spineSpinsRemaining.scale.set(Scale.XY(0.9));			
			this.spinsRemainingContainer.x = Scale.X(1732.83);
			this.spinsRemainingContainer.y = Scale.Y(2.5);
		}		
		this.spineSpinsRemaining?.state?.setAnimation(0, "anim", true);
		//spinsRemainingContainer.scale.set(Scale.XY(0.7));

		//create text spins remaning info
		let spinRemainingTextInfoPIXIAPP = new Text(this.translator.t.totalleftHoldAndSpin, {
			fontFamily: 'NotoSansDisplay-Bold',
			fontSize: 35,
			fontWeight: 'bold',
			fill: ["#F20505", "#F20505", "#F20505", "#F20505", "#F20505"], // gradient
			stroke: 'white',
			strokeThickness: 10,
			wordWrap: true,
			lineJoin: 'round',
			align: "center",
			dropShadow: true,
			dropShadowColor: "#000000",
			dropShadowDistance: 5,
			dropShadowAngle: 0.52,
			dropShadowAlpha: 1,
			//textBaseline : "middle",			
		});
		spinRemainingTextInfoPIXIAPP.anchor.set(0.5, 0.5);
		spinRemainingTextInfoPIXIAPP.scale.set(1, -1);
		spinRemainingTextInfoPIXIAPP.position.set(-50, 0);


		//create spins remaning 
		let spinRemainingTextPIXIAPP = new Text(this.session.RunsRemaining, {
			fontFamily: 'NotoSansDisplay-Bold',
			fontSize: 100,
			fontWeight: 'bold',
			fill: ["#F20505", "#F20505", "#F20505", "#F20505", "#F20505"], // gradient
			stroke: 'white',
			strokeThickness: 10,
			//wordWrap: true,			
			lineJoin: 'round',
			dropShadow: true,
			dropShadowColor: "#000000",
			dropShadowDistance: 5,
			dropShadowAngle: 0.52,
			dropShadowAlpha: 1,
			//textBaseline : "middle",			
		});
		spinRemainingTextPIXIAPP.anchor.set(0.5, 0.5);
		spinRemainingTextPIXIAPP.scale.set(1, -1);
		spinRemainingTextPIXIAPP.position.set(100, 0);
		this.spinRemainingTextPIXIAPP = spinRemainingTextPIXIAPP;

		//add container to spine
		let containerchildrensSpine = this.spineSpinsRemaining?.children as Container[];
		containerchildrensSpine?.forEach((container) => {
			if (container.name == "containerValue") {
				container.addChild(spinRemainingTextInfoPIXIAPP);
				container.addChild(spinRemainingTextPIXIAPP);
			}
		});

		this.translator.SetOnLanguageChangedCallback(() => {

			//winTextPIXIAPP.text = this.translator.t.totalwinHoldAndSpin;
			spinRemainingTextInfoPIXIAPP.text = this.translator.t.totalleftHoldAndSpin;
		});
	}

	public override async ResourcesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void> {
		await super.ResourcesLoaded(loadingStage, resourceManager);

		for (let [name, pot] of this.layoutPotsElementsMap) {
			await pot.ResourcesLoaded(resourceManager)
		};

	}

	protected override async PrepareSpineResources(resourceManager: IWriteOnlyResourceManager) {
		await super.PrepareSpineResources(resourceManager);

		for (let [name, pot] of this.layoutPotsElementsMap) {
			await pot.PrepareResources(resourceManager)
		};
	}

	//private bonusConfig: MultiBonusCommonConfiguration;
	protected isWinContainerShowWinMovedJumped = false;
	protected TotaltSpins = 0;
	protected multiplierHit = 1;
	public override Prepare(bonusStartConfig: IBonusStartConfig): void {
		super.Prepare(bonusStartConfig);
		this.isMovedWincontainer = false;
		this.isWinContainerShowWinMovedJumped = false;
		//this.updateSpin = 0;
		this.TotaltSpins = (bonusStartConfig.actions.find(a => a.Phase == "Start") as SpinAndHoldStartAction ).SpinsStarted;		
		this.multiplierHit = this.startAction.Multiplier 
}

	protected override WinCountShow() {
		super.WinCountShow();
		//change position for winContainer 
		this.SetPositionAwardContainer()


		// if (globalThis.jackpotDisplayGlobal != null) {
		// 	TweenLite.to(globalThis.jackpotDisplayGlobal.View(), 0.8, {
		// 		alpha: 0
		// 	});
		// }
	}
	protected isMovedWincontainer: boolean = false;
	protected timeoutCometShowtime: ITimeout = null;
	protected SetPositionAwardContainer() {

		this.bonusGameAwardViewPIXIAPP.position.y = Scale.Y(0);
		//if (Settings.Screens == 3 && Settings.Enable2plus1 == false) return;

		if (this.scatterPositions[0].AwardOptionPosition.Row >= this.spinnableReels2.GetWindowSymbolSize().Height / 2 || this.playWindow.Height <= 3 ) {
			//top position
			this.bonusGameAwardViewPIXIAPP.position.y = Scale.Y(-58);
			//if(Settings.Enable2plus1 == true )this.bonunsGameAwardViewPIXIAPP.position.y = Scale.Y(1085);
			this.isMovedWincontainer = false;
		} else {
			//bottom postion
			this.bonusGameAwardViewPIXIAPP.position.y = Scale.Y(908);
			//if(Settings.Enable2plus1 == true )this.bonunsGameAwardViewPIXIAPP.position.y = Scale.Y(1988);
			this.isMovedWincontainer = true;
		}
	}

	protected override InternalNextComet() {
		//this.isShowed = true;
		this.currentScatterCometIndex++;
		if (this.currentScatterCometIndex >= this.scatterPositions.length) {
			// Log.Debug(this.logGroup, "Comets complete");			
			this.panel.SetWin(service.moneyFormatter.FormatCreditCurrentDenom(this.startAction.WinSinceGameStart.TotalWin.InCents), service.moneyFormatter.FormatCurrency(this.startAction.WinSinceGameStart.TotalWin.InCents))
			this.timeoutFinalMessageState.Start();
		}
		else {
			if (SpinAndHoldState.CometCollect == this.stateMachine.State()) {
				this.isShowed = false;
				if ((this.scatterPositions[this.currentScatterCometIndex].AwardOptionPosition.Row >= this.spinnableReels2.GetWindowSymbolSize().Height / 2) && this.isMovedWincontainer == true && this.playWindow.Height >= 4 ) {
					//this.animBottomToTopWinContainer.restart();
					let yPosition = Scale.Y(-58)
					if (Settings.Enable2plus1 == true) yPosition = Scale.Y(1085);
					gsap.to(this.bonusGameAwardViewPIXIAPP
						, {
							duration: 1,
							y: yPosition,
						});

					//its moved need turn of flag for dont move all time
					this.isMovedWincontainer = false;
					//add some delay for wait move container and later show comet anim
					this.timeoutCometShowtime.Start();
					//setTimeout(() => { this.CometShowtime(this.scatterPositions[this.currentScatterCometIndex]); }, 1000)
				} else {
					//jumps to cometshowTime dosent need add delay here
					this.CometShowtime(this.scatterPositions[this.currentScatterCometIndex]);
				}
			}
		}
	}

	//Set new destination for coment because this bonus use more positions for commet 
	protected override DestinationComet(): Point {
		if (Settings.Screens == 3) {
			if (this.scatterPositions[this.currentScatterCometIndex].AwardOptionPosition.Row < this.spinnableReels2.GetWindowSymbolSize().Height / 2 && this.playWindow.Height >= 4 ) {
				// where the win is on the bottom
				return TranslateScreen1To1(new Rect(Scale.X(0), Scale.Y(1080 + 1080), Scale.W(1920), Scale.H(1080))).Center();
			}
			else {
				// where the win is on the top
				return TranslateScreen1To1(new Rect(Scale.X(0), Scale.Y(1080), Scale.W(1920), Scale.H(1080))).Center();
			}
		}else if (Settings.Screens == 2){
		    if (this.scatterPositions[this.currentScatterCometIndex].AwardOptionPosition.Row < this.spinnableReels2.GetWindowSymbolSize().Height / 2 && this.playWindow.Height >= 4 ) {
		    	// where the win is on the bottom
		    	return TranslateScreen1To1(new Rect(Scale.X(0), Scale.Y(990), Scale.W(1920), Scale.H(1080))).Center();
		    	}
		    else {
		    	// where the win is on the top
		    	return new Rect(Scale.X(0), Scale.Y(200), Scale.W(1920), Scale.H(1080)).Center();
		    }
		}
		else if (Settings.Screens == 1)
		{
			if (this.scatterPositions[this.currentScatterCometIndex].AwardOptionPosition.Row <= this.spinnableReels2.GetWindowSymbolSize().Height / 2 - 1) {
				// where the win is on the bottom
				return TranslateScreen1To1(new Rect(Scale.X(0), Scale.Y(1080 + 1080), Scale.W(1920), Scale.H(1080))).Center();
			}
			else {
				// where the win is on the top
				return TranslateScreen1To1(new Rect(Scale.X(0), Scale.Y(1080), Scale.W(1920), Scale.H(1080))).Center();
			}

		}
		
		throw new Error(`DesinationComet not implemented for ${Settings.Screens}`);

	}

	//Update Spin Value 
	protected override OnSpinBegin(): void {
		super.OnSpinBegin()		
		if(this.spinsStats != null) this.spinsStats.text = this.translator.t.bonusSpinsRemainingAndTotal(this.session.RunsRemaining, this.TotaltSpins)	
	}

	public override Start(): void {
		super.Start();
		if(this.spinsStats != null) this.spinsStats.text = this.translator.t.bonusSpinsRemainingAndTotal(this.session.RunsRemaining, this.TotaltSpins)
	}

	public override GameExit(): void {
		super.GameExit()
		this.multiplierHit = 1;
		this.layoutPotsElementsMap.forEach(ele=>{
			ele.Destroy();
		})
		Safe(()=>{ this.spinsStats.destroy();});
		if (globalThis.jackpotDisplayGlobal != null) {
			TweenLite.to(globalThis.jackpotDisplayGlobal.View(), 2.5, {
				alpha: 1
			});
		}
	}

	public override async TransitionLoaded(resourceManager: IReadOnlyResourceManager) {
		await super.TransitionLoaded(resourceManager);

		this.transitionView.onTransitionStart = () => {
			this.OnTransitionStarted();
			if (this.startAction.Types.includes(MultiBonusType.Double) && globalThis.jackpotDisplayGlobal != null && Settings.Screens == 2 || globalThis.jackpotDisplayGlobal != null && Settings.Enable2plus1 == true) {
				TweenLite.to(globalThis.jackpotDisplayGlobal.View(), 0.2, {
					alpha: 0
				});
			}
		}		
	}

	protected override SetScaleSpinsRemaining(containerViewScreen2 : Container){
		if(Settings.Screens == 2){
			containerViewScreen2.scale.set(0.7);
			containerViewScreen2.position.set(Scale.X(277.5), Scale.Y(277.5));
		}			
	}
	
	protected override CreateContainersPIXIAPPScreen2() {
		super.CreateContainersPIXIAPPScreen2();
		if (Settings.Screens == 2) {
			this.bonusGameInfoStats.position.set(Scale.X(0), Scale.Y(0));
		}
	}
}